const notifications = (state: any) => state.notifications;

export const notificationsSelectors = {
  notifications,
};
